import { render, staticRenderFns } from "./choseCourseSchoolBasePreview.vue?vue&type=template&id=1251a0b2&scoped=true&"
import script from "./choseCourseSchoolBasePreview.vue?vue&type=script&lang=js&"
export * from "./choseCourseSchoolBasePreview.vue?vue&type=script&lang=js&"
import style0 from "./choseCourseSchoolBasePreview.vue?vue&type=style&index=0&id=1251a0b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251a0b2",
  null
  
)

export default component.exports